import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import './scss/app.scss';
import Footer from './components/layout/Footer';
import InfluencerForm from './components/InfluencerForm';
import axios from 'axios';

const settings = {
    contactUs: 'http://www.codemasters.com/contact-us/',
    termsAndCond: 'https://terms.codemasters.com/en',
    privacyPolicy: 'https://terms.codemasters.com/en#privacy',
    modernSlavery: 'http://www.codemasters.com/wp-content/uploads/2019/03/Codemasters-Group-Holdings-plc-Modern-Slavery-Statement-March-2019-electronic-signature.pdf',
    genderGap: 'http://www.codemasters.com/wp-content/uploads/2019/04/CM-Pay-Gap-Report-2018.pdf'
}

export default class App extends Component {
    static displayName = App.name;

    componentDidMount() {
        axios.get('/api/clientstore')
            .then((response) => {
                this.getSettings(response.data);               
            })
            .catch(err => console.log(err.response));
    }

    getSettings = (s) => {
        settings.contactUs = s.contactUs;
        settings.termsAndCond = s.termsAndCond;
        settings.privacyPolicy = s.privacyPolicy;
        settings.modernSlavery = s.modernSlavery;
        settings.genderGap = s.genderGap;
    };

    render () {
    return (
        <div className="App">
            <div className="container">
                <InfluencerForm settings={settings}/>
            </div>
            <Footer settings={settings}/>
        </div>
    );
    }
}
